<div class="multi-quota-nesting-selection me-2">
  <ps-ui-accordion
    [closeOthers]="true"
    [checkForChanges]="true"
    (toggle)="onGroupSelection($event)"
  >
    <ng-container
      *ngFor="
        let eachNestingGroupData of (nestingGroupData$ | async) || [];
        let i = index;
        trackBy: trackByGroup
      "
    >
      <ps-ui-accordion-section
        [isExpanded]="
          eachNestingGroupData.id === (selectedNestingGroup$ | async)?.id
        "
        [keepOpen]="true"
      >
        <ng-template psUiAccordionTitle>
          <div class="d-flex justify-content-between align-items-center">
            <ng-container *ngIf="eachNestingGroupData.titleState === 'view'">
              <span class="accordion-title title-break-word">{{
                eachNestingGroupData.id
              }}</span>
              <div class="actions">
                <button
                  psUiButton
                  type="button"
                  title="Edit Quota Nested Title"
                  class="me-2"
                  (click)="onEditNestedGroupTitle(eachNestingGroupData, $event)"
                >
                  <i class="fa fa-pencil" aria-hidden="true"></i>
                </button>
                <button
                  psUiButton
                  type="button"
                  title="Delete Quota Nested"
                  (click)="onDeleteNestedGroup(eachNestingGroupData, $event)"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </button>
              </div>
            </ng-container>

            <ng-container *ngIf="eachNestingGroupData.titleState === 'edit'">
              <ps-ui-input-with-confirmation
                psUiNestingTitleValidator
                width="70%"
                maxLength="50"
                [value]="eachNestingGroupData.id"
                (confirm)="
                  confirmNestingTitleUpdate(eachNestingGroupData, $event)
                "
                (cancel)="discardNestingTitleUpdate(eachNestingGroupData)"
              ></ps-ui-input-with-confirmation>
            </ng-container>
          </div>
        </ng-template>

        <ul class="qualifications">
          <li
            *ngFor="
              let qualification of eachNestingGroupData.qualifications;
              let qualIndex = index;
              trackBy: trackByQualification
            "
          >
            <input
              class="m-1 form-check-input"
              type="checkbox"
              id="qualification-{{ eachNestingGroupData.id }}-{{
                qualification.qualification_code
              }}"
              name="qualification-{{ eachNestingGroupData.id }}-{{
                qualification.qualification_code
              }}"
              [checked]="qualification.isChecked"
              [disabled]="!eachNestingGroupData.qualificationSelection"
              (click)="
                validateQualificationSelectionLimit(
                  eachNestingGroupData,
                  $event
                )
              "
              (change)="
                onQualificationSelection(
                  eachNestingGroupData,
                  qualIndex,
                  $event
                )
              "
            />
            <span>
              {{ qualification.qualification_name }}
            </span>
          </li>
        </ul>
      </ps-ui-accordion-section>
    </ng-container>
  </ps-ui-accordion>
</div>
